<template>
    <div class="outer">
        <!-- 付款单详情弹窗 -->
        <el-dialog width="65%" destroy-on-close title="付款单详情" :close-on-click-modal="false"
            :visible="detailVisible" @close="detailVisible = false">
            <el-descriptions :column="2" border style="margin-bottom: 20px;">
                <el-descriptions-item label="付款单号">{{ detailForm.paymentNo || '--' }}</el-descriptions-item>
                <el-descriptions-item label="来源类型">{{ sourceName(detailForm.sourceType) }}</el-descriptions-item>
                <el-descriptions-item label="关联单号">{{ detailForm.sourceNo || '--' }}</el-descriptions-item>
                <el-descriptions-item label="供应商">{{ detailForm.supplierName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="应付金额">{{ detailForm.payableAmount }}元</el-descriptions-item>
                <el-descriptions-item label="已付金额">{{ detailForm.paidAmount }}元</el-descriptions-item>
                <el-descriptions-item label="状态">{{ detailForm.payStateName || payStateName(detailForm.payState) }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ detailForm.createTime || '--' }}</el-descriptions-item>
            </el-descriptions>
            <div class="listTop">付款流水</div>
            <el-table border :row-style="{ height: '50px' }" style="width: 100%" :data="detailForm.payFlows || []">
                <el-table-column align="center" label="流水号" prop="flowNo"></el-table-column>
                <el-table-column align="center" label="付款金额(元)" prop="payAmount"></el-table-column>
                <el-table-column align="center" label="操作人" prop="operatorName"></el-table-column>
                <el-table-column align="center" label="付款时间" prop="payTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line"></el-table-column>
                <el-table-column align="center" label="备注" prop="remarks"></el-table-column>
            </el-table>
            <el-empty v-if="!detailForm.payFlows || detailForm.payFlows.length === 0" :image-size="80"
                description="暂无付款流水"></el-empty>
        </el-dialog>

        <!-- 付款处理弹窗（财务 27） -->
        <el-dialog width="40%" destroy-on-close title="处理付款单" :close-on-click-modal="false"
            :visible="processVisible" @close="closeProcessDialog">
            <el-form ref="processForm" :model="processForm" :rules="processRules" label-width="110px">
                <el-form-item label="付款单号">
                    <el-input v-model="processForm.paymentNo" disabled></el-input>
                </el-form-item>
                <el-form-item label="应付金额">
                    <el-input v-model="processForm.payableAmount" disabled></el-input>
                </el-form-item>
                <el-form-item label="已付金额">
                    <el-input v-model="processForm.paidAmount" disabled></el-input>
                </el-form-item>
                <el-form-item label="本次付款金额" prop="payAmount" required>
                    <el-input type="number" :min="0.01" v-model="processForm.payAmount"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input type="textarea" :rows="3" v-model="processForm.remarks" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="rejectPay">驳 回</el-button>
                <el-button type="primary" :loading="btnLoading" @click="processPay">付 款</el-button>
            </span>
        </el-dialog>

        <div class="topSearch">
            <el-form class="queryRow" inline :model="queryForm">
                <el-form-item label="来源类型" class="queryCol">
                    <el-select v-model="queryForm.sourceType" clearable placeholder="请选择" @change="onSearch" @clear="onSearch">
                        <el-option :value="1" label="采购单"></el-option>
                        <el-option :value="2" label="个人自采"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款状态" class="queryCol">
                    <el-select v-model="queryForm.payState" clearable placeholder="请选择" @change="onSearch" @clear="onSearch">
                        <el-option value="1" label="待处理"></el-option>
                        <el-option value="2" label="已付款"></el-option>
                        <el-option value="3" label="部分付款"></el-option>
                        <el-option value="4" label="已驳回"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款单号" class="queryCol">
                    <el-input placeholder="请输入" clearable @clear="onSearch" v-model="queryForm.paymentNo"></el-input>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 付款统计（FR-FN-04，接口未就绪时隐藏） -->
        <el-card v-if="statVisible" class="statCard">
            <div class="statItem">待处理金额：<span class="statNum">{{ statData.pendingAmount || 0 }}</span> 元</div>
            <div class="statItem">已付款金额：<span class="statNum">{{ statData.paidAmount || 0 }}</span> 元</div>
            <div class="statItem">付款单数：<span class="statNum">{{ statData.count || 0 }}</span> 笔</div>
        </el-card>

        <el-table v-loading="loading" border class="table" :row-style="{ height: '50px' }"
            style="width: 100%;height: 62vh;overflow: auto;" :data="payList">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column align="center" label="付款单号" prop="paymentNo" width="180"></el-table-column>
            <el-table-column align="center" label="来源类型" prop="sourceType">
                <template slot-scope="scope">
                    {{ sourceName(scope.row.sourceType) }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="关联单号" prop="sourceNo"></el-table-column>
            <el-table-column align="center" label="供应商" prop="supplierName"></el-table-column>
            <el-table-column align="center" label="应付金额(元)" prop="payableAmount"></el-table-column>
            <el-table-column align="center" label="已付金额(元)" prop="paidAmount"></el-table-column>
            <el-table-column align="center" label="状态" prop="payState">
                <template slot-scope="scope">
                    <el-tag :type="payStateTagType(scope.row.payState)">{{ payStateName(scope.row.payState) }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="创建时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line"></el-table-column>
            <el-table-column align="center" label="操作" prop="operate" width="200">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-document"
                        @click="openDetail(scope.row)">详情</el-button>
                    <el-button type="text" icon="el-icon-edit" v-if="canProcess && scope.row.payState == 1"
                        @click="openProcess(scope.row)">处理</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]"
                :current-page="queryForm.page" background layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { getPaymentOrderList, queryPaymentOrder, processPaymentOrder, rejectPaymentOrder, paymentStatistics } from '@/api/goods/paymentOrder.js';
import { canProcessPayment } from "@/views/goods/permission.js";
export default {
    data() {
        return {
            canProcess: canProcessPayment(), // 付款单处理权限（财务 27）
            loading: false,
            total: 0,
            payList: [],
            queryForm: {
                sourceType: null,
                payState: null,
                paymentNo: '',
                page: 1,
                limit: 10,
            },
            // 详情
            detailVisible: false,
            detailForm: {},
            // 处理
            processVisible: false,
            processForm: {
                paymentNo: '',
                payableAmount: '',
                paidAmount: '',
                payAmount: '',
                remarks: '',
            },
            processRules: {
                payAmount: [
                    { required: true, message: '请输入本次付款金额' },
                ],
            },
            btnLoading: false,
            // 统计
            statVisible: false,
            statData: {},
        }
    },
    created() {
        this.getPayList();
        this.getStatistics();
    },
    methods: {
        sourceName(sourceType) {
            return String(sourceType) === '2' ? '个人自采' : '采购单';
        },
        payStateName(payState) {
            switch (String(payState)) {
                case '1': return '待处理';
                case '2': return '已付款';
                case '3': return '部分付款';
                case '4': return '已驳回';
                default: return '--';
            }
        },
        payStateTagType(payState) {
            switch (String(payState)) {
                case '1': return 'warning';
                case '2': return 'success';
                case '3': return 'primary';
                case '4': return 'danger';
                default: return '';
            }
        },
        // 列表
        getPayList() {
            this.loading = true;
            getPaymentOrderList(this.queryForm).then(res => {
                this.loading = false;
                if (res && res.code === 200) {
                    this.total = res.count;
                    this.payList = res.data;
                } else {
                    this.payList = [];
                    this.total = 0;
                }
            }).catch(() => {
                this.loading = false;
                this.payList = [];
                this.total = 0;
            });
        },
        onSearch() {
            this.queryForm.page = 1;
            this.getPayList();
        },
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.getPayList();
        },
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.getPayList();
        },
        // 详情
        openDetail(row) {
            queryPaymentOrder({ paymentNo: row.paymentNo }).then(res => {
                if (res && res.code === 200) {
                    this.detailForm = res.result || {};
                } else {
                    this.detailForm = { ...row };
                }
            }).catch(() => {
                this.detailForm = { ...row };
            });
            this.detailVisible = true;
        },
        // 处理
        openProcess(row) {
            this.processForm = {
                paymentNo: row.paymentNo,
                payableAmount: row.payableAmount,
                paidAmount: row.paidAmount,
                payAmount: ((row.payableAmount || 0) - (row.paidAmount || 0)).toFixed(2),
                remarks: '',
            };
            this.processVisible = true;
        },
        closeProcessDialog() {
            this.processForm = { paymentNo: '', payableAmount: '', paidAmount: '', payAmount: '', remarks: '' };
            this.$refs.processForm && this.$refs.processForm.resetFields();
            this.processVisible = false;
        },
        processPay() {
            this.$refs.processForm.validate((valid) => {
                if (!valid) return;
                const payAmount = Number(this.processForm.payAmount);
                const remaining = Number((this.processForm.payableAmount || 0) - (this.processForm.paidAmount || 0));
                if (payAmount <= 0 || payAmount > remaining + 0.001) {
                    this.$message({ type: 'error', message: `本次付款金额须在 0.01 ~ ${remaining.toFixed(2)} 之间` });
                    return;
                }
                this.btnLoading = true;
                processPaymentOrder({
                    paymentNo: this.processForm.paymentNo,
                    payAmount: payAmount.toFixed(2),
                    remarks: this.processForm.remarks,
                }).then(res => {
                    this.btnLoading = false;
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: '付款成功' });
                        this.processVisible = false;
                        this.getPayList();
                        this.getStatistics();
                    }
                }).catch(() => {
                    this.btnLoading = false;
                    this.$message({ type: 'warning', message: '付款失败（付款单接口待后端联调）' });
                });
            });
        },
        rejectPay() {
            this.$prompt('请输入驳回原因', '驳回付款单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /[^ \x20]+/,
                inputErrorMessage: '驳回原因不能为空!'
            }).then(({ value }) => {
                this.btnLoading = true;
                rejectPaymentOrder({
                    paymentNo: this.processForm.paymentNo,
                    remarks: value,
                }).then(res => {
                    this.btnLoading = false;
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: '已驳回' });
                        this.processVisible = false;
                        this.getPayList();
                        this.getStatistics();
                    }
                }).catch(() => {
                    this.btnLoading = false;
                    this.$message({ type: 'warning', message: '驳回失败（付款单接口待后端联调）' });
                });
            }).catch(() => { });
        },
        // 统计（FR-FN-04，接口未就绪时隐藏）
        getStatistics() {
            paymentStatistics({}).then(res => {
                if (res && res.code === 200) {
                    this.statData = res.result || {};
                    this.statVisible = true;
                } else {
                    this.statVisible = false;
                }
            }).catch(() => {
                this.statVisible = false;
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.outer {
    height: 80vh;

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        position: absolute;
        bottom: 10px;
        right: 10px;
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;
    }

    .listTop {
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 450;
    }

    .statCard {
        margin-bottom: 15px;
        display: flex;

        .statItem {
            margin-right: 40px;
            font-size: 14px;

            .statNum {
                font-size: 18px;
                font-weight: 600;
                color: #409EFF;
            }
        }
    }

    .table {
        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
